import React from "react";
import TourismEvent from "../../components/TourismEvent/TourismEvent";

const events = props => {
  const style = {
    display: 'grid',
    gridTemplateColumns: 'repeat(3,1fr)',
    gridGap: '10px',
    gridAutoRows: 'minmax(100px,auto)'
  }

  return (
    <div style={style}>
      {props.list.map(l => (
      <TourismEvent
        key={l.id}
        type={l.type}
        title={l.titulo}
        link={l.link}
        image={l.imageUrl}
        info={l.info}
        handleDeleteButton={() => props.onClickDeleteButton(l.id)}
        handleEditButton={() => props.onClickEditButton(l)}
      />
      ))}
    </div>
  );
};

export default events;
